export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "reviews__fitGuidanceSlider--headerPartOne": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["How it Runs:"])},
        "reviews__fitGuidanceSlider--headerPartTwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Based on Nuulyer feedback"])},
        "reviews__fitGuidanceSlider--likeYouLegend": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["Like You (", _interpolate(_list(0)), ")"])},
        "reviews__fitGuidanceSlider--allLegend": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])}
      }
    }
  })
}
